export const roleDefault = () => {
    return {
        id: null,
        name: null,
        costs: null,
        stocks: null,
        permissions: [],
        templates: [],
        voucher_types: [],
        voucher_types_modification_permissions: []
    }
}

export default {
    role: roleDefault(),
    permissions: [],
    categories: [],
    categories_specials: {
      selected:null,
    },
    permissions_specials: [],
    category: {
      selected:null
    },
    copyPermissions: [],
    roles: [],
    actionForm: 'create',
    users:[],
    params: {
        page: 1,
        perPage: 30,
        name:''

      },
    templates_select: [],
    vouchers_type_select: [],
    accounting_models_select: [],
}



// WEBPACK FOOTER //
// ./src/modules/roles/state.js